<script setup>
import { ref, watch, computed, onMounted, onUnmounted } from 'vue'
const url = `${process.env.VUE_APP_CDN_ARCHIVOS}/presupuesto/datos/datos_narrativa_presupuesto_v4.json`
const cdnArchivos = process.env.VUE_APP_CDN_ARCHIVOS

const json_narrativa = ref()
const anios = ref()
const laDona = ref()
const sisdaiGrafica = ref()
const anio_seleccionado = ref('2022')
const variables = ref([
  {
    id: 'resto',
    color: '#FFFFFF',
    nombre: 'Resto',
  },
])
const datos = ref([
  {
    id: 'resto',
    monto_ejercido: 29283408979.9,
  },
])
const variables_visibles = computed(() =>
  variables.value.filter(d => d.id !== 'resto').map(d => d.id)
)
const altoSisdaiGrafica = ref(300)

watch(
  () => sisdaiGrafica.value?.ancho_grafica,
  nv => {
    if (nv > 500) {
      altoSisdaiGrafica.value = 500
    } else {
      altoSisdaiGrafica.value = nv
    }
  }
)
const miNarrativa = ref()
const vinetas_anio = computed(() =>
  json_narrativa.value
    ? json_narrativa.value[anio_seleccionado.value].map(d => d.bullet)
    : ['', '', '', '', '', '']
)
const datos_anio = computed(() =>
  json_narrativa.value
    ? json_narrativa.value[anio_seleccionado.value].map(d => d.datos)
    : []
)
const variables_anio = computed(() =>
  json_narrativa.value
    ? json_narrativa.value[anio_seleccionado.value].map(d => d.variables)
    : []
)
fetch(url)
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok ' + response.statusText)
    }
    return response.json()
  })
  .then(data => {
    json_narrativa.value = data
    anios.value = Object.keys(json_narrativa.value)

    variables.value = variables_anio.value[0]
    datos.value = datos_anio.value[0]
  })
  .catch(error => {
    console.error('Error fetching the JSON:', error)
  })
onMounted(() => {
  // Agregué esta línea para resolver un bug que estaba surgiendo en safari
  setTimeout(() => window.dispatchEvent(new Event('resize')), 500)
  window.addEventListener('scroll', ajustandoZIndex)
})
onUnmounted(() => {
  window.removeEventListener('scroll', ajustandoZIndex)
})
watch(
  () => miNarrativa.value?.seccion_visible,
  nv => {
    for (var i = 0; i < variables_anio.value.length; i++) {
      if (nv === i - 1 && nv !== variables_anio.value.length - 2) {
        datos.value = datos_anio.value[i]
        variables.value = variables_anio.value[i]
      }
      if (nv >= variables_anio.value.length - 2) {
        datos.value = datos_anio.value[i]
        variables.value = variables_anio.value[i].filter(d => d.id !== 'resto')
      }
    }
  }
)
function ajustandoZIndex() {
  document.querySelector('.contenido-fondo-sticky').style.zIndex = '1'
  setTimeout(
    () => (
      (document.querySelector('.contenido-fondo-sticky').style.zIndex = '0'), 5
    )
  )
}
watch(anio_seleccionado, nv => {
  if (
    miNarrativa.value?.seccion_visible <
    json_narrativa.value?.['' + nv].length - 2
  ) {
    datos.value =
      json_narrativa.value?.['' + nv]?.[
        miNarrativa.value?.seccion_visible + 1
      ]?.datos
    variables.value =
      json_narrativa.value?.['' + nv]?.[
        miNarrativa.value?.seccion_visible + 1
      ]?.variables
  } else {
    datos.value =
      json_narrativa.value?.['' + nv]?.[
        json_narrativa.value?.['' + nv].length - 1
      ]?.datos
    variables.value = json_narrativa.value?.['' + nv]?.[
      json_narrativa.value?.['' + nv].length - 1
    ]?.variables.filter(d => d.id !== 'resto')
  }
})
</script>

<template>
  <div
    class="contenedor"
    id="narrativa-presupuesto"
  >
    <div class="contenedor p-t-2 contenedor-selector-anios">
      <div class="contenedor p-b-1">
        <select
          style="width: 100px; margin-left: auto; margin-right: auto"
          name="anio"
          id="anio"
          v-model="anio_seleccionado"
          class="m-t-0"
        >
          <option
            v-for="anio in anios"
            :value="anio"
            :key="anio"
          >
            {{ anio }}
          </option>
        </select>
      </div>
    </div>
    <div class="contenedor ancho-lectura">
      <SisdaiNarrativa
        ref="miNarrativa"
        :altura_sensor="0"
        :separacion="+1"
      >
        <template #contenido-fondo-sticky>
          <div class="elementos-fondo">
            <SisdaiGraficas
              class="sin-atribuciones"
              ref="sisdaiGrafica"
              :alto="altoSisdaiGrafica"
              :margenes="{ arriba: 0, abajo: 0, derecha: 0, izquierda: 0 }"
              :style="{ '--contenedor-vis-alto-minimo-vis': 'auto' }"
            >
              <template #globo-informacion>
                <SisdaiGraficasGloboInfo
                  :ancho="280"
                  v-show="variables_visibles.includes(laDona?.datos_hover?.id)"
                >
                  <template>
                    <p>
                      <span
                        class="globo-informacion-punto-color"
                        :style="{
                          background: variables.filter(
                            d => d.id === laDona?.datos_hover?.id
                          )[0]?.color,
                        }"
                      ></span>
                      {{
                        variables.filter(
                          d => d.id == laDona?.datos_hover?.id
                        )[0]?.nombre
                      }}: {{ laDona?.datos_hover?.porcentaje }} % |
                      {{
                        laDona?.datos_hover?.monto_ejercido.toLocaleString('en')
                      }}
                    </p>
                  </template>
                </SisdaiGraficasGloboInfo>
              </template>
              <SisdaiDona
                ref="laDona"
                :datos="datos"
                :variables="variables"
                :clave_categoria="'id'"
                :clave_cantidad="'monto_ejercido'"
                :variables_visibles="variables_visibles"
                :color_dona_fondo="'#fff'"
                :radio_interno="0.21"
                :radio_externo="0.39"
              />
              <template #panel-pie-vis>
                <SisdaiNomenclatura
                  v-if="miNarrativa?.seccion_visible >= 0"
                  :variables="variables?.filter(d => d.id != 'resto')"
                ></SisdaiNomenclatura>
                <div class="flex flex-contenido-centrado">
                  <a
                    :href="`${cdnArchivos}/presupuesto/hcti_cuenta_publica_2022_metadato.zip`"
                    class="boton boton-primario boton-chico m-y-1"
                    download
                    >Descarga datos
                    <span
                      aria-hidden="true"
                      class="pictograma-archivo-descargar"
                    ></span>
                  </a>
                </div>
              </template>
            </SisdaiGraficas>
          </div>
        </template>
        <div
          class="vineta p-1 contenedor"
          v-for="(vineta, i) in vinetas_anio"
          :key="i"
        >
          <div class="contenedor-vineta contenedor alineacion-centrada">
            <p class="p-2 texto-centrado">
              {{ vineta }}
            </p>
          </div>
        </div>
      </SisdaiNarrativa>
    </div>
  </div>
</template>
<style scoped lang="scss">
#narrativa-presupuesto {
  .contenedor-vineta {
    background: var(--color-conahcyt-3);
    color: var(--color-conahcyt-0);

    max-width: 354px;
  }

  .narrativa-graficas {
    transform: none;
    :deep(.contenido-fondo-sticky) {
      top: 120px;
      z-index: 0;
      @media screen and (max-width: 768px) {
        top: 140px;
      }
      .elementos-fondo {
        position: relative;
        z-index: 1;
      }
    }
  }

  .contenedor-selector-anios {
    position: sticky;
    top: 46px;
    z-index: 3;
    background-color: var(--fondo);
    @media screen and (max-width: 768px) {
      top: 72px;
    }
  }
}
</style>
